import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../components/api";
import "bootstrap/dist/css/bootstrap.css";
import Axios from "axios";
import Select from "react-select";
import AuthContext from "../context/AuthContext";

function Formsa(props) {
  function refreshPage() {
    window.location.reload(false);
  }

  const [message, setMessage] = useState(null);

  let intsub = props.intsu;
  console.log(intsub);
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));
  let { user } = useContext(AuthContext);
  let intplan = props.intpa;
  let sub = props.su;
  let u = props.usr;
  let f = props.full;
  let s = props.sit;
  let c = props.con;
  let o = props.opti;
  let p = props.plana;
  let exp = props.exp;
  let du = props.due;
  let no = props.notes;
  let site_name = props.site;
  let w = props.WAP;
  let core = props.core;
  let cpe = props.cpe_mac; // CPE Variable

  console.log(exp);

  const [username, setusername] = useState("");
  const [pass] = useState(props.pass);

  const [password, setpassword] = useState("");
  const [site, setsite] = useState("");
  const [due, setdue] = useState("");
  const [subnotes, setnotes] = useState("");

  const [consumption_option, setcon] = useState("");
  const [connectivity, setcona] = useState("");
  const [expiration_date, setda] = useState("");
  const [suffix, setsuffix] = useState("-");

  const [expiryDateDisabled, setExpiryDateDisabled] = useState(false);
  let [plans, setplans] = useState([]);
  const [client, setclient] = useState("");
  const [plani, setplano] = useState(intplan);
  let [notes, setcil] = useState([]);

  const [wirelessAccessPoint, setWirelessAccessPoint] = useState("");
  const [sites, setSites] = useState([]);
  const [wirelessAccessPoints, setWirelessAccessPoints] = useState([]);
  const [selectedSite, setSelectedSite] = useState("");
  const [cores, setCores] = useState([]);
  const [selectedCore, setSelectedCore] = useState("");

  const [cpeMacAddress, setCpeMacAddress] = useState(""); // New state
  const [cpeError, setCpeError] = useState(""); // New state

  const [selectedSiteLabel, setSelectedSiteLabel] = useState("");

  const specialSites = ["AYSAR", "EZONE", "SAEED"];

  console.log(expiration_date);
  console.log(plani);
  console.log(client);
  useEffect(() => {
    let isMounted = true;

    const getclients = async () => {
      try {
        const response = await Axios.get(`${API_URL}/administration/clients/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
            "Content-Type": "application/json",
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200 && isMounted) {
          setcil(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    const getplans = async () => {
      try {
        const response = await Axios.get(`${API_URL}/radius/plans/internet`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
            "Content-Type": "application/json",
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200 && isMounted) {
          setplans(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };
    const getpermisions = async () => {
      try {
        const response = await Axios.get(`${API_URL}/administration/groups/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
            "Content-Type": "application/json",
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200 && isMounted) {
          setExpiryDateDisabled(response.data === "Reseller");
        }
      } catch (error) {
        console.error(error);
      }
    };
    getpermisions();
    getclients();
    getplans();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    const fetchSites = async () => {
      try {
        const response = await Axios.get(`${API_URL}/radius/sites/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: { username: user.username },
        });

        if (response.status === 200) {
          const options = response.data.map((item) => ({
            label: item.site_name,
            value: item.site_id,
          }));
          setSites(options);
        }
      } catch (error) {
        console.error("Error fetching sites:", error);
      }
    };

    fetchSites();

    const fetchCores = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/radius/fiber/cores/select/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
            },
            params: { username: user.username },
          }
        );

        if (response.status === 200) {
          const options = response.data.map((item) => ({
            label: item.code,
            value: item.core_id,
          }));
          setCores(options);
        }
      } catch (error) {
        console.error("Error fetching sites:", error);
      }
    };

    fetchSites();
    fetchCores();
  }, [authTokens.access, user.username]);

  const fetchWirelessAccessPoints = async (siteName) => {
    try {
      const response = await Axios.get(
        `${API_URL}/radius/wirelessAccessPoint/`,
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: { username: user.username, site: siteName },
        }
      );

      if (response.status === 200) {
        const options = response.data.map((item) => ({
          label: item.name,
          value: item.ap_id,
        }));
        setWirelessAccessPoints(options);

        if (specialSites.includes(siteName)) {
          const defaultOption = options.find((opt) => opt.label === siteName);
          if (defaultOption) setWirelessAccessPoint(defaultOption.value);
        }
      }
    } catch (error) {
      console.error("Error fetching wireless access points:", error);
    }
  };

  const options = notes.map((item) => {
    return {
      label: item.fullname_en,
      value: item.client_id,
    };
  });

  const plano = plans.map((item) => {
    const planNameWithoutSM = item.plan_name.replace("SM-", "");
    return {
      label: planNameWithoutSM,
      value: item.internet_plan_id,
    };
  });
  const opta = [
    { value: "LIMITED", label: "LIMITED" },
    { value: "UNLIMITED", label: "UNLIMITED" },
  ];
  const cona = [
    { value: "Fiber", label: "Fiber" },
    { value: "Wireless", label: "Wireless" },
  ];
  const dua = [
    { value: "First", label: "First" },
    { value: "Half", label: "Half" },
  ];

  // Function to show the message for a given duration
  const showMessage = (message, type = "success") => {
    setMessage({ text: message, type });

    // Close the modal after 3 seconds
    setTimeout(() => {
      props.closeModal();
    }, 1200);

    // Clear the message after 5 seconds
    setTimeout(() => {
      setMessage(null);
    }, 1000);
  };

  let handleSubmit = async (e) => {
    let lowercasedUsername = username.toLowerCase();
    e.preventDefault();
    Axios.post(
      `${API_URL}/radius/subscriptions/`,
      {
        Action: "Put",
        Subscription_id: sub,
        internet_subscription_id: intsub,
        internet_plan_id: intplan,
        username: lowercasedUsername,
        client_id: client,
        plan_id: plani,
        consumption_option: consumption_option,
        connectivity: connectivity,
        expiry_date: expiration_date,
        site: site,
        suffix: suffix,
        label: "",
        due: due,
        notes: subnotes,
        password: password,
        userdealer: user.username,
        site_id: selectedSite,
        wireless_access_point_id: wirelessAccessPoint,
        core_id: selectedCore,
      },
      {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
      }
    )
      .then((response) => {
        console.log(response);
        // refreshPage(); // You may or may not want to reload the page after successful submission
        showMessage("Edit successful!", "success"); // Show the success message
      })
      .catch((error) => {
        console.log(error);
        showMessage("Edit failed!", "danger"); // Show the error message
      });
  };

  const handleSiteChange = (opt) => {
    setSelectedSite(opt.value);
    const selectedSite = sites.find(
      (selectedSite) => selectedSite.value === opt.value
    )?.label;
    setSelectedSiteLabel(opt.label);
    if (selectedSite) {
      setWirelessAccessPoints([]);
      fetchWirelessAccessPoints(selectedSite);
    }
  };

  const isValidMacAddress = (value) => {
    const macRegex = /^([0-9A-F]{2}:){5}[0-9A-F]{2}$/;
    return macRegex.test(value);
  }; // Valid Mac Address Functions

  useEffect(() => {
    setCpeError(
      cpeMacAddress && !isValidMacAddress(cpeMacAddress)
        ? "Invalid CPE MAC Address format"
        : ""
    );
  }, [cpeMacAddress]); // CPE MAC Address Validation Use Effect

  const handleAddMac = async () => {
    console.log("Add MAC Address clicked");
    try {
      const payload = {
        subscription_id: sub,
        internet_subscription_id: intsub,
        cpe_mac_address: cpeMacAddress,
        userdealer: user.username,
        site_id: selectedSite || null, // pass selected site
        ap_id: wirelessAccessPoint || null, // pass selected AP
        connectivity: connectivity || null, // pass selected connectivity
      };
      const response = await Axios.post(
        `${API_URL}/radius/cpemacaddress/add/`,
        payload,
        { headers: { Authorization: `Bearer ${authTokens.access}` } }
      );

      console.log(response);
      if (response.data.status) {
        showMessage(response.data.status, "success");
      }
    } catch (error) {
      console.error(error);
      const errMsg =
        error.response?.data?.error || "Error adding CPE MAC address";
      showMessage(errMsg, "danger");
    }
  };

  const handleRemoveMac = async () => {
    console.log("Remove MAC Address clicked");
    try {
      const response = await Axios.post(
        `${API_URL}/radius/cpemacaddress/remove/`,
        {
          subscription_id: sub, // Your subscription ID
          internet_subscription_id: intsub, // Your internet subscription ID
          userdealer: user.username, // Your username
        },
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
        }
      );
      console.log(response);
      // Display success message returned from backend
      if (response.data.status) {
        showMessage(response.data.status, "success");
        // Optionally, update your state if you need to reflect the removal,
        // for example, resetting the cpeMacAddress to an empty string or "-" based on your UX.
        setCpeMacAddress("-");
      }
    } catch (error) {
      console.error(error);
      if (error.response && error.response.data.error) {
        showMessage(error.response.data.error, "danger");
      } else {
        showMessage("Error removing CPE MAC address", "danger");
      }
    }
  }; // Remove MAC Address Function

  const handleCopyCPE = () => {
    const input = document.createElement("input");
    input.value = cpe;
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
  }; // Copy CPE Function

  return (
    <div className="testi">
      <div className="mod">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>
              Username:
              <input
                className="form-control"
                type="text"
                value={username}
                placeholder={u}
                onChange={(e) => setusername(e.target.value)}
              />
            </label>
          </div>
          <div className="form-group">
            <label>
              Password:
              <input
                className="form-control"
                type="text"
                value={password}
                placeholder={pass}
                onChange={(e) => setpassword(e.target.value)}
              />
            </label>
          </div>
          <div className="form-group">
            <label>
              Client Name:
              <Select
                className="search-line"
                placeholder={f}
                options={options}
                onChange={(opt) => setclient(opt.value)}
              />
            </label>
          </div>
          <div className="form-group">
            <label>
              Plan Name:
              <Select
                className="search-line"
                placeholder={p}
                options={plano}
                onChange={(opt) => setplano(opt ? opt.value : "")}
              />
            </label>
          </div>

          <label>
            Notes:
            <input
              className="form-control"
              type="text"
              value={subnotes}
              placeholder={no}
              onChange={(e) => setnotes(e.target.value)}
            />
          </label>
          <label>
            Expiry Date:
            <input
              type="date"
              id="expiryDate"
              name="expiryDate"
              className="form-control"
              defaultValue={exp ? exp.substr(0, 10) : ""}
              onChange={(e) => setda(e.target.value)}
              disabled={expiryDateDisabled}
            />
          </label>
          <label>
            Conectivity Option:
            <Select
              className="search-line"
              placeholder={c}
              options={cona}
              onChange={(opt) => setcona(opt.value)}
            />
          </label>
          {/* Show Site options if connectivity is "Wireless" */}
          {(connectivity === "Wireless" || c === "Wireless") &&
            connectivity !== "Fiber" && (
              <label>
                Site:
                <Select
                  className="search-line"
                  placeholder={site_name}
                  options={sites}
                  onChange={(opt) => {
                    handleSiteChange(opt);
                  }}
                />
              </label>
            )}

          {/* Show Wireless Access Point options if Site is selected */}
          {(connectivity === "Wireless" || c === "Wireless") &&
            connectivity !== "Fiber" &&
            !specialSites.includes(selectedSiteLabel) && (
              <label>
                Wireless Access Point:
                <Select
                  className="search-line"
                  placeholder={w}
                  options={wirelessAccessPoints}
                  onChange={(opt) => {
                    setWirelessAccessPoint(opt.value);
                  }}
                />
              </label>
            )}
          {(connectivity === "Fiber" || c === "Fiber") &&
            connectivity !== "Wireless" && (
              <label>
                Core:
                <Select
                  className="search-line"
                  placeholder={core}
                  options={cores}
                  onChange={(opt) => {
                    setSelectedCore(opt.value);
                  }}
                />
              </label>
            )}
          {/* Show Mac Address input if Wireless Access Point is selected */}
          {(connectivity === "Wireless" || c === "Wireless") &&
            connectivity !== "Fiber" &&
            !specialSites.includes(selectedSiteLabel) && (
              <div className="me-3">
                <label className="form-label">CPE MAC Address:</label>
                <div className="d-flex align-items-center">
                  <input
                    type="text"
                    className={`form-control ${cpeError ? "is-invalid" : ""}`}
                    style={{ width: "250px" }}
                    value={cpeMacAddress}
                    onChange={(e) => {
                      const raw = e.target.value;
                      const rawNoCols = raw.replace(/:/g, "");
                      const cleaned = rawNoCols.replace(/[^0-9A-Fa-f]/g, "");

                      // if characters were dropped, it means a non‑hex was typed
                      setCpeError(cleaned.length !== rawNoCols.length);

                      // format into pairs + colons, uppercase, max 12 hex digits
                      let formatted = "";
                      for (let i = 0; i < cleaned.length && i < 12; i += 2) {
                        if (i > 0) formatted += ":";
                        formatted += cleaned.substring(i, i + 2).toUpperCase();
                      }
                      setCpeMacAddress(formatted);
                    }}
                    maxLength={17} // “AA:BB:CC:DD:EE:FF”
                    placeholder={cpe}
                  />

                  <button
                    type="button"
                    className={`btn ms-2 ${
                      cpe && cpe.trim() !== "" && cpe.trim() !== "-"
                        ? "btn-danger"
                        : "btn-success"
                    }`}
                    onClick={
                      cpe && cpe.trim() !== "" && cpe.trim() !== "-"
                        ? handleRemoveMac
                        : handleAddMac
                    }
                  >
                    {cpe && cpe.trim() !== "" && cpe.trim() !== "-"
                      ? "Remove Mac Address"
                      : "Add Mac Address"}
                  </button>
                </div>

                {cpeError && (
                  <div
                    className="invalid-feedback"
                    style={{ display: "block", fontSize: "0.85rem" }}
                  >
                    Only hexadecimal digits (0–9, A–F) are allowed.
                  </div>
                )}
              </div>
            )}
          <div className="fo">
            <button type="submit" className="btn btn-primary btn-md">
              Edit
            </button>
          </div>
        </form>
      </div>

      {/* Popup Message */}
      {message && (
        <div
          className={`alert alert-${message.type} alert-dismissible fade show`}
          role="alert"
          style={{
            position: "fixed",
            bottom: "10px",
            margin: "10px",
            right: "10px",
            zIndex: "9999",
          }}
        >
          {message.text}
        </div>
      )}
    </div>
  );
}

export default Formsa;
